import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { buildPublisherStructuredData } from 'utils/StructuredData';
import classes from './CardBlogA.module.scss';

const CardBlogA = (props) => {
  const {
    title,
    description,
    creator,
    publishedDate,
    image,
    imageAltText = '',
    modifiedDate,
    imageHeight,
    imageWidth,
  } = props;

  const publishedDateFormat = publishedDate ? new Date(publishedDate) : null;
  const modifiedDateFormat = modifiedDate ? new Date(modifiedDate) : null;

  return (
    <div className={classes.container}>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: buildPublisherStructuredData({ ...props, publishedDateFormat, modifiedDateFormat }),
        }}
      />
      <div className={classes.headingRow}>
        {title &&
          <h1
            dangerouslySetInnerHTML={{ __html: title }}
            className={classes.title}
          />}
        <div className={classes.creator}>
          {creator && `By: ${creator}`}
        </div>
        <div className={classes.publishedDate}>
          {publishedDateFormat && moment(publishedDateFormat).format('MMMM D, YYYY')}
        </div>
      </div>
      <div className={classes.detailRow}>
        {
          image &&
          <img
            className={classes.image}
            src={image}
            alt={imageAltText}
            width={imageWidth}
            height={imageHeight}
            loading='lazy'
          />
        }
        {description && <div
          className={classes.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />}
      </div>
    </div>
  );
};

CardBlogA.propTypes = {
  /**
   * Title of the Blog
  */
  title: PropTypes.string,
  /**
   * Content of the Blog
  */
  description: PropTypes.string,
  /**
   * Author of the blog
  */
  creator: PropTypes.string,
  /**
   * Date when the blog was published
  */
  publishedDate: PropTypes.string,
  /**
   * Url of the image
  */
  image: PropTypes.string,
  /**
   * Alt text for image
  */
  imageAltText: PropTypes.string,
  /**
   * Last date when the blog was modified
  */
  modifiedDate: PropTypes.string,
  /**
   * Image height
  */
  imageHeight: PropTypes.number,
  /**
   * Image width
  */
  imageWidth: PropTypes.number,
};

export default CardBlogA;
